import { Component, OnInit } from '@angular/core';
import { AlertasModales } from '../../helpers/alertasModales';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpleadosServicio } from '../../services/empleado.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup;
  modalMsg: any;
  mostrarError = false;
  loading = false;
  email: string;
  token: string;

  constructor(
    private modals: AlertasModales,
    private empleadoService: EmpleadosServicio,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    
  }

  ngOnInit() {
    this.getQueryParmas();
    this.initForm();
    $('body').css('background-color',  'rgba(230, 230, 230, 0.55)');
  }

  private getQueryParmas() {
    this.route.queryParams.subscribe(params => {
      if (!params.e && !params.t) {
        this.router.navigate(['404']);
      } else {
        this.email = params.e;
        this.token = params.t;
        this.empleadoService.verificartokenPass(params.e, params.t)
        .subscribe(() => {}, () => {
          this.router.navigate(['404']);
        });
      }
    });
  }
  
  private initForm(): void {
    this.form = new FormGroup({
      'new_pass': new FormControl('', [Validators.required, Validators.minLength(6)]),
      're_pass': new FormControl('', [Validators.required, Validators.minLength(6)]),
    });
  }

  guardar() {
    if (this.form.get('new_pass').value !== this.form.get('re_pass').value) {
      this.modalMsg = { message: 'Las contraseñas no coinciden', error: true };
      this.mostrarError = true;
    } else {

      if (this.form.valid && !this.loading) {
        this.loading = true;
        const data = {
          ...this.form.value,
          token: this.token,
          email: this.email
        };
        this.empleadoService.nuevaContrasena(data).subscribe( res => {
          this.modalMsg = res;
          this.mostrarError = true;
          setTimeout(() => {
            this.mostrarError = false;
            this.router.navigate(['/login']);
            this.loading = false;
          }, 2300);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/forgot-password/forgot-password.component.ts